export function toggleChatbox(action: string) {
  if (window.$crisp) {
    window.$crisp.push(['do', `chat:${action}`])
  }
}

export function triggerChatbox(params?: {
  message?: string
  trigger?: string
}) {
  if (window.$crisp) {
    if (params?.message) {
      window.$crisp.push(['do', 'chat:open'])

      window.$crisp.push([
        'do',
        'message:send',
        ['text', params.message],
      ])
    }

    if (params?.trigger) {
      window.$crisp.push([
        'do',
        'trigger:run',
        [params.trigger],
      ])
    }
  }
}
